import React from 'react'
import PropTypes from 'prop-types'
import { kebabCase } from 'lodash'
import Helmet from 'react-helmet'
import { graphql, Link } from 'gatsby'
import Content, { HTMLContent } from '../components/Content'
import banner from '../img/banner.jpeg'



export const BlogPostTemplate = ({
  content,
  contentComponent,
  description,
  tags,
  title,
  helmet,
}) => {
  const PostContent = contentComponent || Content

  return (
<div>

    <section className="section" style={{backgroundColor:'white',  backgroundAttachment: 'fixed'}}>
      {/*<meta name="viewport" content="width=device-width, initial-scale=1"/>*/}
      {/*<video autoPlay muted loop id="myVideo">*/}
        {/*<source src={move} type="video/mp4"/>*/}
        {/*Your browser does not support HTML5 video*/}
      {/*</video>*/}



      {helmet || ''}
      <div className="container content">
        <div className="columns">
          <div style={{ display:'inline-grid', marginLeft:'auto', marginTop:'20px'}}>
            <div className="news-font-left">Good Music Good Times</div>
          </div>
          <div className="column is-10 is-offset-1" style={{backgroundColor: 'rgba(255,255, 255, 0.99)', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}>
            <h1 className="title is-size-2 has-text-weight-bold is-bold-light">
              {title}
            </h1>
            <p>{description}</p>
            <PostContent content={content} />
            {tags && tags.length ? (
              <div style={{ marginTop: `4rem` }}>
                <h4>Tags</h4>
                <ul className="taglist">
                  {tags.map(tag => (
                    <li key={tag + `tag`}>
                      <Link to={`/tag/${kebabCase(tag)}/`}>{tag}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </div>
          <div style={{ display:'inline-grid', marginLeft:'auto', marginTop:'20px'}}>
            <div className="news-font-right">Where The Culture Lives</div>
          </div>
        </div>
      </div>
    </section>
</div>
  )
}

BlogPostTemplate.propTypes = {
  content: PropTypes.node.isRequired,
  contentComponent: PropTypes.func,
  description: PropTypes.string,
  title: PropTypes.string,
  helmet: PropTypes.object,
}

const BlogPost = ({ data }) => {
  const { markdownRemark: post } = data

  return (
    <>
      <BlogPostTemplate
        content={post.html}
        contentComponent={HTMLContent}
        description={post.frontmatter.description}
        helmet={
          <Helmet titleTemplate="%s | Blog">
            <title>{`${post.frontmatter.title}`}</title>
            <meta
              name="description"
              content={`${post.frontmatter.description}`}
            />
          </Helmet>
        }
        tags={post.frontmatter.tags}
        title={post.frontmatter.title}
      />
    </>
  )
}

BlogPost.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
}

export default BlogPost


/**
 * Necessary for the build but I don't know why
 */
export const pageQuery = graphql`
  query BlogPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        description
        tags
      }
    }
  }
`
